import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var createUpdatedTypologiesObj = (_typologiesSelected, _macroTypologyObj) => {
  //Case 0: no typologies selected
  if (!_typologiesSelected.length) return null;
  var _typologiesIds = [];
  var _typologiesIdList = [];
  for (var t of _typologiesSelected) {
    _typologiesIds.push(t.listingTypologyId);
    _typologiesIdList = [..._typologiesIdList, ...t.typologyIdList];
  }
  var url = "";
  /* If we select just one typology, and it is not allTypologies, we set our url to its url */
  if (_typologiesSelected.length === 1 && !_typologiesSelected[0].allTypologies) {
    url = _typologiesSelected[0].url;
  }
  /* In any other case, we are dealing or with multiple typologies selected, or with allTypologies selected.
  *  In this case, we will set the macroTypology url
  *  */else url = _macroTypologyObj[_typologiesSelected[0].macroTypologyID].url;
  return {
    macroTypologyID: _typologiesSelected[0].macroTypologyID,
    url,
    listingTypologyId: _typologiesSelected[0].listingTypologyId,
    //We can have multiple typologies
    selectedListingTypologiesIDList: _typologiesIds,
    selectedTypologiesIDList: _typologiesIdList
  };
};
/*
* Gets the most specific typology by the given macroTypology.
* So, for example, the macroTypology 1 ('Residential') of the typology 18 ('trilocali') will return the typology
* with listingTypologyID 1, macroTypology 1 and with the shortest typologyIdList which is ('appartamenti')
* */
export var getSpecificTypologyId = macroTypologyId => {
  var listingTypologies = window["_options"].listingTypologies || [];
  var candidates = listingTypologies.filter(l => !l.filterName && !l.filterValue && l.typologyIdList.includes(macroTypologyId));
  candidates.sort((a, b) => a.typologyIdList.length < b.typologyIdList.length ? -1 : 1);
  return !candidates.length ? null : candidates[0];
};